module.exports = __webpack_public_path__ + "img/andrew-pena-echo-park.1aff39d.jpg";